'use client';

import { QueryClientProvider as QCProvider, QueryClient } from '@tanstack/react-query';
import type { FunctionComponent } from 'react';

export const QueryClientProvider: FunctionComponent<{ children: React.ReactNode }> = ({ children }) => {
  const queryClient = new QueryClient();

  return <QCProvider client={queryClient}>{children}</QCProvider>;
};
